import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import apiCall from "./../../API/API";
import { toast, ToastContainer } from "react-toastify";
import RoiIncome from "./RoiIncome";
import RoiLevelIncome from "./ROILevelIncome";
import RoyaltyIncome from "./RoyaltyIncome";
import LevelIncome from "./LevelIncome";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PayoutControls.css";
import { Container, Row, Col, NavLink, Button } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import debounce from "lodash.debounce";

const PayoutControls = () => {
  const [incomeData, setIncomeData] = useState([]);
  const [totalToday, setTotalToday] = useState();
  const [totalIncome, setTotalIncome] = useState();
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const [search, setsearch] = useState({
    username: "",
    search: "",
    startDate: "",
    endDate: "",
  });
  const [filter, setFilter] = useState("none");
  const [dateFilter, setDateFilter] = useState("default");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search, navigate]);
  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setsearch((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    const queryParams = {
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    console.log(queryParams, "queryParammmmmmmmmmmm");
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchData(queryParams);
  }, [search, startDate, endDate]);

  function handleTabClick(tab) {
    setActiveTab(tab);
    navigate(`/dashboard/${tab}`);
  }

  const fetchData = async () => {
    try {
      const filteredSearch = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );
      const queryParams = new URLSearchParams({
        ...filteredSearch,
      });
      const queryString = queryParams.toString();
      const response = await apiCall("GET", `/payout-report?${queryString}`);
      console.log(response?.data);
      setIncomeData(response?.data);
      setTotalToday(response?.data?.totalTodaySum);
      setTotalIncome(response?.data?.totalSum);
    } catch (error) {
      console.log(error.message);
    }
  };
  var x = 0;
  useEffect(() => {
    if (x == 0) {
      fetchData();
      x++;
    }
  }, []);
  const resetFilter = async () => {
    filterReset();
    try {
      const filteredSearch = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );
      const queryParams = new URLSearchParams({
        ...filteredSearch,
      });
      const queryString = queryParams.toString();
      const response = await apiCall("GET", `/payout-report?${queryString}`);
      console.log(response?.data);
      setIncomeData(response?.data);
      setTotalToday(response?.data?.totalTodaySum);
      setTotalIncome(response?.data?.totalSum);
    } catch (error) {
      console.log(error.message);
    }
  };

  const filterReset = () => {
    setsearch({
      username: "",
      search: "",
      startDate: "",
      endDate: "",
    });
  };

  const AddFilter = () => {
    const queryParams = {
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    fetchData(queryParams);
  };
  return (
    <React.Fragment>
      <Container>
        <Row id="filterRow">
          {/* <span className="filterL">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="align-content-center"></div>
            </div>
          </span> */}

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>

            {/*<Col lg="2" md="4">
              <div>
              
              <input type="text" name='username' placeholder="Search By UserName" value={search.username} onChange={handleChange} />
               </div>
            </Col>*/}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={search.startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={search.endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>

            <div>
              <button className="save filter" onClick={AddFilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>

        <div className="list-container">
          <ul className="list-group">
            <Row md="12" className="justify-content-center">
              <Col md="5" className="justify-center">
                <div className="list-group-item1">
                  <h3>Total Income</h3>
                  <Row>
                    <Col>
                      <div className="list1">
                        <h4>{parseFloat(totalIncome).toFixed(2)}</h4>
                        <p>Total</p>
                      </div>
                    </Col>
                    <Col>
                      <div className="list1">
                        <h4>{parseFloat(totalToday).toFixed(2)}</h4>
                        <p>Today</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {Array.isArray(incomeData?.data) &&
              incomeData?.data?.map((x, i) => (
                <Row md="12" className="justify-content-center">
                  <Col md="5" className="justify-center">
                    <NavLink
                      className={`list-group-item ${
                        activeTab === x?.slug ? "active" : ""
                      }`}
                      onClick={() => handleTabClick(x?.slug)}
                      style={{ cursor: "pointer" }}
                    >
                      <h3>{x?.name}</h3>
                      <Row>
                        <Col>
                          <div className="list">
                            <h4>{parseFloat(x?.totalAmount).toFixed(2)}</h4>
                            <p>Total</p>
                          </div>
                        </Col>
                        <Col>
                          <div className="list">
                            <h4>{parseFloat(x?.todayAmount).toFixed(2)}</h4>
                            <p>Today</p>
                          </div>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col>
                </Row>
              ))}
          </ul>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default PayoutControls;
